/**
 * Detects whether the current browser client is operating on a mobile device (phone or tablet).
 *
 * Why: Mobile operating systems (Android, iOS) do not support the desktop WebSerial API
 * and connect to Meshtastic radios exclusively via WebBluetooth (BLE). Detecting mobile environments
 * allows bypassing unnecessary transport selection dialogs and directly triggering the native
 * Bluetooth pairing picker for a seamless, one-tap mobile workflow.
 *
 * @param customUa - Optional user-agent string override for testing
 * @returns True if running on a mobile phone or tablet
 */
export function isMobileDevice(customUa?: string): boolean {
  const ua = customUa !== undefined ? customUa : (typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');
  
  // 1. Common mobile browser / OS signatures
  const isMobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  
  // 2. Hardware touch capability without WebSerial support
  const hasTouch =
    typeof navigator !== 'undefined' &&
    ((navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      (typeof window !== 'undefined' && 'ontouchstart' in window));
  const hasSerial = typeof navigator !== 'undefined' && 'serial' in navigator;

  return isMobileUa || (!hasSerial && hasTouch);
}
